import { ref, watch } from "vue"
const usetablePageNation = () => {
    const total = ref(0)
    const currentPage = ref(1)
    const pageSize = ref(10)
    const pageOption = ref([])
    const setPages = () => {
        pageOption.value = [];
        let numberOfPages = Math.ceil(total.value / pageSize.value);
        for (let index = 1; index <= numberOfPages; index++) {
            pageOption.value.push(index);
        }
    }

    watch(total, () => {
        setPages()
    })

    watch(pageSize, () => {
        setPages();
        currentPage.value = 1;
    })

    return {
        total,
        currentPage,
        pageSize,
        pageOption
    }
}

export default usetablePageNation